import { render } from "./ThemeProvider.vue?vue&type=template&id=4753db21&ts=true"
import script from "./ThemeProvider.vue?vue&type=script&lang=ts"
export * from "./ThemeProvider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__